const translations = {
  "en": {
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Delete means delete, this portfolio won't come back.": "Delete means delete, this portfolio won't come back.",
    "Delete portfolio?": "Delete portfolio?"
  },
  "zh-tw": {
    "Cancel": "取消",
    "Confirm": "確認",
    "Delete means delete, this portfolio won't come back.": "刪除就是刪除，這個投資組合不會再回來了。",
    "Delete portfolio?": "刪除投資組合？"
  }
};

export default translations;
